import styled from 'styled-components';
import DropdownList from 'react-widgets/lib/DropdownList';

const AuthorizedHeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 62px;
  position: relative;
  z-index: 10;
  &:after {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
    height: 62px;
    background: white;
  }
  @media all and (max-width: 768px) {
    height: 55px;
    &:after {
      height: 55px;
    }
  }
  @media all and (max-width: 576px) {
    position: fixed;
    background: white;
    z-index: 15;
    height: 50px;
    &:after {
      display: none;
    }
  }
`;

const AuthorizedHeader = styled.div`
  max-width: 1600px;
  top: 0;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: 10;
  background-color: ${p => p.theme.color.bg_white};
  height: 62px;
  box-sizing: border-box;
  padding: 0 1em;
  svg {
    height: 55%;    
    width: initial;
    &.azmonica {
      height: 70%;
    }
  }
  .rw-widget {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: flex-end;
  }
  .rw-widget > .rw-widget-container {
    display: flex;
    align-items: center;
    & > * {
      max-width: inherit;
    }
  }
  .rw-widget-picker {
    display: inline-block;
    height: 100%;
  }
  .rw-list-option {
    a {
      color: ${(p) => p.theme.color.text};
    }
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* IE  */
    transform: translateX(-50%);
  }
  @media all and (max-width: 768px) {
    height: 55px;
    padding: 0 1.5em;
    & > img {
      width: 140px;
    }
  }
  @media all and (max-width: 576px) {
    height: 50px;
    padding: 0 1em;
    & > img {
      width: 120px;
    }
  }

  .practitioner-logout-btn {
    border-radius: 4px;
    border: solid 2px ${(p) => p.theme.color.error};
    transition: all 0.25s ease-out;
    &:hover {
      border: solid 2px #fe876f;
      color: #fe876f;
      cursor: pointer;
    }
    font-size: 1em;
    font-weight: 500;
    text-align: center;
    color: ${(p) => p.theme.color.error};
    background-color: #fff;
    padding: 0.45em 1.969em;
    margin: 0 0 0 1.125em;
    outline: none;
  }
`;

const Navigation = styled.ul`
  list-style-type: none;
  position: relative;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
`;

const NavigationItem = styled.li`
  margin-right: 40px;
  padding: 11px 0px;
  ${p =>
    p.isActive &&
    `color: ${p.theme.color.primary}; 
    .rw-dropdown-list-input { color : ${p.theme.color.primary}};
    .rw-i-caret-down:before { color: ${p.theme.color.primary}};`};
  ${p =>
    p.disabled ? `color: ${p.theme.color.label}; cursor: default;` : 'cursor: pointer'};
`;

const NavigationSelect = styled(DropdownList)`  
  &.rw-open {
    .rw-i-caret-down:before {
      content: '\\e800';
      top: -1px;
    }
  }

  .rw-list{
    max-height: 250px;
  }

  .rw-i-caret-down:before {
    position: absolute;
    top: 2px;
    color: ${p => p.active && p.theme.color.primary};
    left: 10px;
  }

  .rw-widget > .rw-widget-container {
    display: inline-block;
  }
  .rw-widget-container {
    border: solid 1px
      ${p =>
    p.active
      ? p.theme.color.primary
      : p.error
        ? p.theme.color.error
        : p.theme.color.border};
  }
  .rw-list-option {
    padding: 0.688em 0.688em;
    font-size: 16px;
    color: ${(p) => p.theme.color.text};
  }
  .rw-widget-picker {
    overflow: visible;
    display: inline-block;
    height: 19px;
  }
  .rw-list-option.rw-state-selected,
  .rw-list-option.rw-state-selected:hover {
    background-color: #f5f5f9;
    border: 0;
    color: ${(p) => p.theme.color.text};
  }

  .rw-list-option.rw-state-focus,
  .rw-list-option.rw-state-focus:hover {
    border: 0;
    color: ${(p) => p.theme.color.text};
  }

  .rw-dropdown-list-input {
    color: ${p => p.active && p.theme.color.primary};
  }
  .rw-popup {
    margin-top: 8px;
    border-radius: 4px;
  }
  .rw-widget-input.rw-widget-picker.rw-widget-container {
    border: none;
    box-shadow: none;
  }
  .rw-select {
    display: inline-table;
  }
  .rw-popup-container{
    min-width: 200px;
  }
`;

const SmallLogo = styled.img`
  width: 160px;
`;

export {
  AuthorizedHeader,
  AuthorizedHeaderWrapper,
  Navigation,
  NavigationItem,
  NavigationSelect,
  SmallLogo
};
